import React, { useState, useEffect, useRef } from "react";
import logo from '../assets/images/hey-visuals-logo.png';
import { Link, useNavigate } from "react-router-dom";
import delat from '../assets/images/dummy-user.jpg';
import { useProfileImage } from './useProfileImage';
import { useLocation } from "react-router-dom";
import AsideMenuItem from "./AsideMenuItem";

const Header = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isAsideMenuOpen, setAsideMenuOpen] = useState(false);
  const { profileImage } = useProfileImage();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const asideMenuRef = useRef(null);

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const toggleAsideMenu = () => {
    setAsideMenuOpen(!isAsideMenuOpen);
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  const closeAsideMenu = () => {
    setAsideMenuOpen(false);
  };

  useEffect(() => {
    if (isAsideMenuOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isAsideMenuOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
      if (asideMenuRef.current && !asideMenuRef.current.contains(event.target)) {
        closeAsideMenu();
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const [nameData, setNameData] = useState({
    name: "",
    email: "",
  });

  const handlesignout = () => {
    try {
      // Retrieve authentication data from localStorage
      const authData = localStorage.getItem('auth');
  
      if (authData) {
        // Parse the authentication data
        const { id: userAid } = JSON.parse(authData);
  
        // Remove authentication data
        localStorage.removeItem('auth');
  
        // Remove the user's profile image if it exists
        if (userAid) {
          localStorage.removeItem(`profileImage${userAid}`);
        }
      }
  
      // Navigate to the login page after a slight delay
      setTimeout(() => {
        navigate('/login');
      }, 10);
    } catch (error) {
      console.error('Error during sign-out process:', error);
    }
  };
  

  useEffect(() => {
    try {
      const authData = localStorage.getItem('auth');
      const storedName = authData ? JSON.parse(authData).name : null;
      const storedEmail = authData ? JSON.parse(authData).email : null;
      setNameData({
        name: storedName,
        email: storedEmail,
      });
    } catch (error) {
      console.error("Error retrieving data from localStorage:", error);
    }
  }, []);

  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.pathname);
  const [isGenerateOpen, setIsGenerateOpen] = useState(false);

  useEffect(() => {
    if (["/captions", "/images", "/avatars", "/videos"].includes(location.pathname)) {
      setIsGenerateOpen(true);
    }
  }, [location.pathname]);

  const handleTabClick = (path) => {
    setActiveTab(path);
    if (["/captions", "/images", "/avatars", "/videos"].includes(path)) {
      setIsGenerateOpen(true);
    } else {
      setIsGenerateOpen(false);
    }
  };

  return (
    <header id="kt_header" className="header align-items-stretch header-fixed" style={{ position: 'fixed', top: "0px", width: '100%', zIndex: '10', boxShadow: '0 0 6px rgba(0, 0, 0, .15)', backgroundColor: 'rgba(255, 255, 255, 1)', }}>
      <div className="container-fluid d-flex align-items-stretch justify-content-between">
        {/* Aside Menu Toggle Button */}
        <div title="Show aside menu" ref={asideMenuRef}
          className="d-flex align-items-center d-lg-none ms-n1 me-2" >
          <button onClick={toggleAsideMenu}
            className="btn btn-icon text-muted btn-active-color-primary w-30px h-30px w-md-40px h-md-40px" >
            <i className="ki-outline ki-abstract-14 fs-3"></i>
          </button>
          {/* Aside Menu */}
          <div className={`aside-menuu w-100  ${isAsideMenuOpen ? "show" : ""}`} onClick={closeAsideMenu}
            style={{
              position: "fixed", top: "0px", left: "0", backdropFilter: 'blur(1px)',
              WebkitBackdropFilter: 'blur(1px)', background: 'rgba(0, 0, 0, 0.2)', boxShadow: "0 3px 5px rgba(0, 0, 0, 0.2)", zIndex: 1, height: '100vh'
            }}>
            <div onClick={(e) => e.stopPropagation()} style={{ boxShadow: "0 .01rem 0.2rem rgba(0, 0, 0, .15)", background: '#fff', width: '100px', paddingTop: '1.25rem !important', paddingBottom: '1.25rem !important', }} id="kt_aside" className="asided overflow-visible pb-5 pt-3   pt-lg-0" >
              <div id="kt_aside_menu" className="aside-menu flex-column-fluid" >
                <div id="kt_aside_menu_wrapper" className="hover-scroll-overlay-y my-2 mb-lg-5 pe-lg-n1" style={{ height: "100vh", width: '100px' }} >
                  <div id="kt_aside_menu" className="menu menu-column menu-title-gray-700 menu-arrow-gray-500 fw-semibold" >
                    {/* Home Tab */}
                    <AsideMenuItem href="/" iconClass="ki-outline ki-home-2 fs-2x" title="Home" isActive={activeTab === "/"} onClick={() => handleTabClick("/")} />
                    {/* Generate Section */}
                    <AsideMenuItem
                      toggleId="generate-collapseOne"
                      iconClass="ki-outline ki-educare fs-2x"
                      title="Generate"
                      isActive={["/captions", "/images", "/avatars", "/videos"].includes(activeTab)}
                      isOpen={isGenerateOpen} // Keep open based on state
                      onToggle={() => setIsGenerateOpen(!isGenerateOpen)}
                    >
                      <div style={{ backgroundColor: "#F8F8F8" }}>
                      <Link
                          to="/videos"
                          className={`menu-link ${activeTab === "/videos" ? "active-tab text-primary" : ""}`}
                          onClick={() => handleTabClick("/videos")}
                          style={{ display: 'flex', flexDirection: 'column' }}
                        >
                          <i className="ki-outline ki-screen fs-1x p-2"></i> Videos
                        </Link>
                        <Link
                          to="/images"
                          className={`menu-link ${activeTab === "/images" ? "active-tab text-primary" : ""}`}
                          onClick={() => handleTabClick("/images")}
                          style={{ display: 'flex', flexDirection: 'column' }}
                        >
                          <i className="ki-outline ki-picture fs-1x p-2"></i> Images
                        </Link>
                        <Link
                          to="/avatars"
                          className={`menu-link ${activeTab === "/avatars" ? "active-tab text-primary" : ""}`}
                          onClick={() => handleTabClick("/avatars")}
                          style={{ display: 'flex', flexDirection: 'column' }}
                        >
                          <i className="ki-outline ki-user-tick fs-1x p-2"></i> Avatars
                        </Link>
                        <Link
                          to="/captions"
                          className={`menu-link ${activeTab === "/captions" ? "active-tab text-primary" : ""}`}
                          onClick={() => handleTabClick("/captions")}
                          style={{ display: 'flex', flexDirection: 'column' }}
                        >
                          <i className="ki-outline ki-instagram fs-1x p-2"></i> Captions
                        </Link>
                       
                      </div>
                    </AsideMenuItem>

                    {/* Other Tabs */}
                    <AsideMenuItem href="/history" iconClass="ki-outline ki-notification-status fs-2x" title="History" isActive={activeTab === "/history"} onClick={() => handleTabClick("/history")} />
                    <AsideMenuItem href="/plans" iconClass="ki-outline ki-abstract-35 fs-2x" title="Plans" isActive={activeTab === "/plans"} onClick={() => handleTabClick("/plans")} />
                    <AsideMenuItem href="/help" iconClass="ki-outline ki-briefcase fs-2x" title="Help"
                      isActive={activeTab === "/help"} onClick={() => handleTabClick("/help")} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Center Logo */}
        <div className="d-flex align-items-center justify-content-center flex-lg-grow-1">
          <Link to="/" className="text-center paddlogo">
            <img src={logo} alt="logo" width="40%" />
          </Link>
        </div>

        {/* User Menu */}
        <div className="d-flex align-items-stretch justify-content-end">
          <div className="d-flex align-items-stretch flex-shrink-0">
            <div
              id="kt_header_user_menu_toggle"
              ref={dropdownRef}
              className="d-flex align-items-center ms-1 ms-lg-3 kt_header_user_menu_toggle_top">
              <div style={{ paddingRight: "18px" }} onClick={toggleDropdown}
                className="cursor-pointer symbol symbol-30px symbol-md-40px" >
                <img src={profileImage || delat} alt="User"
                  className="user-image" />
              </div>

              {/* User Dropdown Menu */}
              <div
                className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px"
                style={{
                  display: isDropdownOpen ? "block" : "none",
                  boxShadow: "0 3px 5px rgb(185 188 188)",
                }}>
                <div className="menu-item px-3">
                  <div className="menu-content d-flex align-items-center px-3">
                    <div className="symbol symbol-50px me-3">
                      <img
                        alt="User Logo"
                        src={profileImage || delat}
                        className="user-image" />
                    </div>
                    <div className="d-flex flex-column">
                      <div className="fw-bold d-flex align-items-center fs-5 user-name">
                        {nameData.name}
                      </div>
                      <a href="#email"
                        className="fw-semibold text-muted text-hover-primary fs-7 user-email te-dec-none">
                        {nameData.email}
                      </a>
                    </div>
                  </div>
                </div>
                <div className="separator my-2"></div>
                <div>
                  <div className="menu-item px-4">
                    <Link
                      to="/plans"
                      className={`menu-link pe-5 ${location.pathname === "/plans" ? "active-link" : ""}`}>
                      My Subscription
                    </Link>
                  </div>
                  <div className="menu-item my-1 px-4">
                    <Link
                      to="/billing"
                      className={`menu-link pe-5 ${location.pathname === "/billing" ? "active-link" : ""}`}>
                      My Billing
                    </Link>
                  </div>
                  <div className="menu-item my-1 px-4">
                    <Link
                      to="/settings"
                      className={`menu-link pe-5 ${location.pathname === "/settings" ? "active-link" : ""}`}>
                      Account Settings
                    </Link>
                  </div>
                </div>
                <div className="menu-item px-4">
                  <Link onClick={handlesignout} className="menu-link pe-5">
                    <span>Sign Out</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
